package ru.chm.gradereport.ui.screens.publicsheet

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import ru.chm.gradereport.data.GradeApi
import ru.chm.gradereport.model.GradeSheetDto
import ru.chm.gradereport.model.StudentStatsDto
import ru.chm.gradereport.ui.components.ErrorBanner
import ru.chm.gradereport.ui.components.ErrorStateCard
import ru.chm.gradereport.ui.components.LoadingBox
import ru.chm.gradereport.ui.components.ScreenHeader
import ru.chm.gradereport.ui.components.ScreenScaffold
import ru.chm.gradereport.ui.screens.course.StudentStatsDialog
import ru.chm.gradereport.ui.screens.course.sheet.GradeSheetTable

@Composable
fun PublicSheetScreen(
    api: GradeApi,
    publicToken: String,
) {
    var sheet by remember { mutableStateOf<GradeSheetDto?>(null) }
    var stats by remember { mutableStateOf<StudentStatsDto?>(null) }
    var loading by remember { mutableStateOf(true) }
    var error by remember { mutableStateOf<String?>(null) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(publicToken) {
        loading = true
        error = null
        try {
            sheet = api.publicSheet(publicToken)
        } catch (e: Exception) {
            error = e.message ?: "Ведомость не найдена"
            sheet = null
        } finally {
            loading = false
        }
    }

    ScreenScaffold {
        ScreenHeader(
            title = sheet?.course?.name ?: "Ведомость",
            subtitle = when {
                sheet != null ->
                    sheet!!.course.description.ifBlank { "Публичная ведомость" }
                error != null -> "Не удалось открыть ведомость"
                else -> "Публичная ведомость"
            },
        )
        when {
            loading -> LoadingBox()
            sheet != null -> {
                ErrorBanner(error) { error = null }
                GradeSheetTable(
                    sheet = sheet!!,
                    editable = false,
                    modifier = Modifier.fillMaxWidth().padding(top = 4.dp),
                    onOpenStats = { studentId ->
                        scope.launch {
                            try {
                                stats = api.publicStudentStats(publicToken, studentId)
                            } catch (e: Exception) {
                                error = e.message
                            }
                        }
                    },
                )
            }
            error != null -> ErrorStateCard(
                title = "Ведомость недоступна",
                message = error!!,
                hint = "Проверьте публичную ссылку. Если курс удалили или ссылку сменили — попросите новую у администратора.",
                modifier = Modifier.padding(top = 4.dp),
            )
        }
    }

    stats?.let { StudentStatsDialog(stats = it, onClose = { stats = null }) }
}
